import { Grid, Input, InputLabel, makeStyles, MenuItem, Select, useTheme } from '@material-ui/core';
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { dataAxureFetch } from '../../helpers/fetch';


const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
};

/**
 * Lets get the style and modify it for size 
 * @param {string} point 
 * @param {string} pointsName 
 * @param {string} theme 
 */
const getStyles =(point, pointsName, theme)=>{
    return {
      fontWeight:
        pointsName.indexOf(point) === -1
          ? theme.typography.fontWeightRegular
          : theme.typography.fontWeightMedium,
    };
}


const useStyles = makeStyles((theme)=>({
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
        paddingLeft: theme.spacing(4),
        textAlign:'center',
        justifyContent: 'center',
    },
}))


export const SelectPoints = ({  filters, handleChange,requestName='NomPuntos' }) => {
    const theme = useTheme();
    const classes = useStyles();

    const uid = useSelector((state) => state.auth.uid);
    const uptws = useSelector((state) => state.auth.ptws);
    const [points, setPoints] = useState([])

    useEffect(() => {
        getPoints();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    /**
     * Function to get points
     */
    const getPoints = async () => {
        const newPoints = await dataAxureFetch(
            {
                solicitud: requestName,
                idCliente: uid,
                ptws: uptws,
            },
            'POST'
        );
        if(newPoints){
            setPoints(newPoints);
        }
        
    };

    
    return (
        <Grid className={classes.container}>
            <InputLabel id="name-points">TWS</InputLabel>
            <Select
                    labelId="names-points"
                    id="multiplePoints"
                    onChange={(event) => handleChange('pointName', event.target.value)}
                    value={filters.pointName}
                    input={<Input />}
                    MenuProps={MenuProps}
            >
                <MenuItem value="" disabled>
                    <em>Ningún TWS</em>
                </MenuItem>

                {points.map((point) => (
                    <MenuItem key={point.nombre} value={point.nombre} style={getStyles(point.nombre, filters.pointName, theme)}>
                        {point.nombre}
                    </MenuItem>
                ))}
            </Select>
        </Grid>
    )
}

SelectPoints.propTypes = {
    filters: PropTypes.object.isRequired,
    handleChange: PropTypes.func.isRequired,
    requestName: PropTypes.string
};